<template>
  <div class="areas">
        <div class="area-data">{{value}}</div>
        <img class="area-icon" src="../../../assets/app/addDate.png" alt="">
  </div>
</template>
<script>
export default {
  props: {
    // 是否展示 model
    showModel: {
      type: Boolean,
      default: false
    },
    // 值
    value: {
      type: [String],
      default: '2018-06-20'
    }
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="less" scoped>
.areas {
  position: relative;
  font-size: 0.3rem;
  // color: #fff;
  min-height: 0.58rem;
  height: 100%;
  line-height: 0.58rem;
  text-align: center;
  border: 0.02rem solid #eee;
  border-radius: 0.06rem;
  padding-right: 0.7rem;
  .area-data {
  }
  .area-icon {
    position: absolute;
    right: 0.2rem;
    top: 0.04rem;
    width: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/appUsage/selectDate.vue